import { useSelector } from 'react-redux';

import * as IssuesV2Store from '../../../redux/issuesV2';
import FilterPanel from '../../generic/Filter/FilterPanel';
import MultiSelectFilter from '../../generic/Filter/MultiSelectFilter';
import useFetchIssuesAction from '../IssuesInbox/hooks/useFetchIssuesAction';
import usePackageManagers from '../IssuesInbox/hooks/usePackageManagers';
import type { MultiSelectFilterOption } from '../../generic/Filter/MultiSelectFilter';

/**
 * Add a multi-select dropdown menu for filtering issues by package manager.
 */
const PackageManagerFilter = () => {
  const packageManagersFilter = useSelector(IssuesV2Store.selectors.getPackageManagersFilter);
  const setPackageManagersFilter = useFetchIssuesAction(IssuesV2Store.actions.setPackageManagersFilter);

  const { isLoading, packageManagers } = usePackageManagers();

  const isDisabled = isLoading || packageManagers.length <= 1;
  const hasSinglePackageManager = packageManagers.length === 1;

  // convert package managers between the simple string[] type (used in the redux store)
  // and the MultiSelectFilterOption[] type used by the multi-select component
  const selectedPackageManagers = packageManagers.filter(
    (packageManager) => packageManagersFilter.includes(packageManager.value),
  );
  const onChange = (selected: MultiSelectFilterOption[]) => {
    setPackageManagersFilter(selected.map((option) => option.value));
  };

  return (
    <FilterPanel>
      <MultiSelectFilter
        title="Package Manager"
        placeholder={isLoading ? 'Loading...' : 'Select one or more...'}
        values={hasSinglePackageManager ? packageManagers : selectedPackageManagers}
        options={packageManagers}
        isDisabled={isDisabled}
        testId="issues-package-managers-filter"
        onChange={onChange}
      />
    </FilterPanel>
  );
};

export default PackageManagerFilter;
